import React from "react";
import { IRealtimeData } from "../../../../types";
import { useTheme } from "@mui/material";

interface IProps {
  orientation: "horizontal" | "vertical";
  title: string;
  rtValue?: IRealtimeData;
  style?: React.CSSProperties;
  decimals?: number;
}


const RtValue = ({orientation, title, rtValue, style, decimals}: IProps) => {
  const theme = useTheme();
  let value = rtValue?.Value;

  if (typeof rtValue?.Value === "number") {
    value = rtValue.Value.toFixed(decimals ?? 0);
  }


  return (
    <div className="display-grid"
         style={{
           gridTemplateRows: orientation === "horizontal" ? undefined : "auto auto",
           gridTemplateColumns: orientation === "horizontal" ? "1fr 1fr" : undefined,
           justifyItems: "stretch",
           alignItems: "center"
         }}>
      <strong style={{ color: theme.palette.text.secondary }}>{title}</strong>
      <strong style={{ fontSize: "1.2em", textAlign: orientation === "vertical" ? "center" : "right", ...style }} >{value}</strong>
    </div>
  );
};

export default RtValue;